var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assignments"},[_c('ModelsList',{staticClass:"assignments__cardModels"}),_c('div',{staticClass:"assignments__container"},[_c('MonitorsList',{staticClass:"assignments__cardMonitors"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }